module.exports = __webpack_public_path__ + "static/aboutUs-f83cda0a766a46b7a11bd4069907416e.jpg";